import {
    NoteText,
    NoteItemWrapper,
} from '@ui/drawer/common/noteItem/noteItem.styles'
import { FC, PropsWithChildren } from 'react'
import Typography from '@/ui/components/typography'

interface InfoItemProps extends PropsWithChildren {
    title?: string
    className?: string
    testId?: string
}

const NoteItem: FC<InfoItemProps> = ({ children, title, testId }) => {
    return (
        <NoteItemWrapper className="info-item" data-testid={testId ?? title}>
            <Typography className="title" component="h3" variant="s-bold">
                {title}
            </Typography>
            <NoteText>
                <Typography className="content" variant="s-regular">
                    {children}
                </Typography>
            </NoteText>
        </NoteItemWrapper>
    )
}

export default NoteItem
